import React from 'react';
import './Game.css';

const CELL_SIZE = 20;
const WIDTH = 800;
const HEIGHT = 600;


class Cell extends React.Component {
    render() {
      const { x, y} = this.props;
      return (
          <div className="Cell" style={{
            left: `${CELL_SIZE * x + 1}px`,
            top: `${CELL_SIZE * y + 1}px`,
            width: `${CELL_SIZE - 1}px`,
            height: `${CELL_SIZE -1}px`,
          }} />
      );
    }
}

class Game extends React.Component {
    constructor() {
        super();
        this.canvas = React.createRef();
        this.rows = HEIGHT/CELL_SIZE;
        this.cols = WIDTH/CELL_SIZE;
        this.board = this.makeEmptyBoard();
    }

    state = {
        cells: [],
        isRunning: false,
        interval: 100,
        genCount: 0,
        step: false,
    }

    // create an empty board
    makeEmptyBoard() {
        let board = [];
        for (let y = 0; y < this.rows; y++) {
          board[y] = [];
        for (let x = 0; x < this.cols; x++) {
          board[y][x] = false;
        }
     }
     return board;
    }

    getElementOffset() {
        const rect = this.boardRef.getBoundingClientRect();
        const doc = document.documentElement;

        return {
            x : (rect.left + window.pageXOffset) - doc.clientLeft,
            y:  (rect.top + window.pageYOffset) - doc.clientTop,
        };
    }

    // create cells from this.board
    makeCells() {
        let cells = [];
        for (let y = 0; y < this.rows; y++) {
          for (let x = 0; x < this.cols; x++) {
              if (this.board[y][x]) {
                  cells.push({ x, y });
              }
           }
        }
        return cells;
    }

    handleClick = (event) => {
        const elemOffset = this.getElementOffset();
        const offsetX = event.clientX - elemOffset.x;
        const offsetY = event.clientY - elemOffset.y;
        let canvas = document.getElementById('canvas');
        let rect = canvas.getBoundingClientRect();
        const x = Math.floor(offsetX / CELL_SIZE);
        // const y = Math.floor(offsetY / CELL_SIZE);
        let y = Number((Math.ceil((event.pageY - rect.top - window.scrollY) /CELL_SIZE))) - 1;
        console.log(x,y)
        if (x >= 0 && x <= this.cols && y >= 0 && y <= this.rows) {
            this.board[y][x] = !this.board[y][x];
        }
        this.setState({ cells: this.makeCells() });
    }

    runGame = () => {
        this.setState({ isRunning: true, step: false });
        this.runIteration();
    }

    stepthroughGame = () => {
        this.setState({ isRunning: true, step: true});
        this.runIteration();
        this.setState({ isRunning: false });
    }

    stopGame = () => {
        this.setState({ isRunning: false });
        if (this.timeoutHandler) {
            window.clearTimeout(this.timeoutHandler);
            this.timeoutHandler = null;
        }
    }

    runIteration() {
        let newBoard = this.makeEmptyBoard();

        for (let y = 0; y < this.rows; y++) {
            for (let x = 0; x < this.cols; x++) {
                let neighbors = this.calculateNeighbors(this.board, x , y);
                if (this.board[y][x]) {
                    if (neighbors === 2 || neighbors === 3) {
                        newBoard[y][x] = true;
                    } else {
                        newBoard[y][x] = false;
                    }
                } else {
                    if (!this.board[y][x] && neighbors === 3) {
                        newBoard[y][x] = true;
                    }
                }
            }
        }
        this.board = newBoard;
      
        this.setState((prevState) => (
            {genCount: prevState.genCount + 1, cells: this.makeCells(),}
        ))
        if(!this.state.step) {
            this.timeoutHandler = window.setTimeout(() => {
                this.runIteration();
            },(this.state.interval));
        }
    }

   /**
     * Calculate the number of neighbors at point (x, y)
     * @param {Array} board 
     * @param {int} x 
     * @param {int} y 
     */


    // this method below computes the number of neighbors of given (x , y)
    calculateNeighbors(board, x , y) {
        let neighbors = 0;
        const dirs = [[-1, -1], [-1, 0], [-1, 1], [0, 1], [1, 1], [1, 0], [1, -1], [0, -1]];
        for (let i = 0; i < dirs.length; i++) {
           const dir = dirs[i];
           let y1 = y + dir[0];
           let x1 = x + dir[1];

           if(x1 >= 0 && x1 < this.cols && y1 >= 0 && y1 < this.rows && board[y1][x1]) {
              neighbors++;
           }
        }
        return neighbors;
    }

    handleIntervalChange = (event) => {
        this.setState({ interval: event.target.value });
    }

    handleClear = () => {
        this.board = this.makeEmptyBoard();
        this.setState({ cells: this.makeCells() , genCount: 0 });
    }

    handleRandom = () => {
        for (let y = 0; y < this.rows; y++) {
            for (let x = 0; x < this.cols; x++) {
                this.board[y][x] = (Math.random() >= 0.5);
            }
        }
        this.setState({ cells: this.makeCells() });
    }

    
    render() {
        const { isRunning } = this.state;
        return (
            <div>
                <div id="canvas" className="Board" ref={this.canvas}
                style={{width: WIDTH, height: HEIGHT,backgroundSize: `${CELL_SIZE}px ${CELL_SIZE}px`}}
                onClick={this.handleClick}
                ref={(n) => {this.boardRef = n; }}>
                {this.state.cells.map(cell => (
                  <Cell 
                  x={cell.x} 
                  y={cell.y} 
                  key={`${cell.x}, ${cell.y}`}
                   />
                ))}
                </div>

            <div className="controls">
            Update every <input value={this.state.interval} onChange={this.handleIntervalChange} /> msec
            { isRunning ?
                <button className="button" onClick={this.stopGame}>Stop</button>:
                <button className="button" onClick={this.runGame}>Run</button>
            }
            <button className="button" onClick={this.handleRandom}>Random</button>
            <button className="button" onClick={this.stepthroughGame}>Step</button>
            <button className="button" onClick={this.handleClear}>Clear</button>
            <h4>Generation: {this.state.genCount}</h4>
            </div>
        </div>
        );
    }
}

export default Game;
